export const TIMEOUTS = {
  DEBOUNCE_SEARCH: 300,
  COOLDOWN_TIMER: 1000,
  COOLDOWN_DEFAULT: 60,
  COOLDOWN_RATE_LIMIT: 300,
};

export const FALLBACK_IMAGES = {
  POSTER_SMALL: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNjQiIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCA0OCA2NCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMCAwaDQ4djY0SDBWMHoiIGZpbGw9IiMyMzI3MmEiLz48cGF0aCBkPSJNMTYgMjBoMTZ2NGgtMTZ2LTR6TTEyIDI4aDI0djRIMTJ2LTR6TTEyIDM2aDI0djRIMTJ2LTR6IiBmaWxsPSIjMzc0MTUxIi8+PC9zdmc+',
  POSTER_LARGE: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgwIiBoZWlnaHQ9IjQyMCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI4MCA0MjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTAgMGgyODB2NDIwSDBWMHoiIGZpbGw9IiMyMzI3MmEiLz48cGF0aCBkPSJNOTAgMTgwaDEwMHY0MEg5MHYtNDB6TTcwIDI0MGgxNDB2NDBINzB2LTQwek03MCAyODBoMTQwdjQwSDcwdi00MHoiIGZpbGw9IiMzNzQxNTEiLz48L3N2Zz4=',
};

export const INPUT_LIMITS = {
  COMMENT_MAX_LENGTH: 500,
  SEARCH_MIN_LENGTH: 2,
};

export const SCROLL_THRESHOLDS = {
  INFINITE_SCROLL: 0.8,
  LAZY_LOAD_MARGIN: '200px',
};

export const ANIMATION_DELAYS = {
  CARD_STAGGER: 50,
  LIST_ITEM_STAGGER: 30,
};

export const YEAR_CONSTRAINTS = {
  MIN_YEAR: 1990,
  CURRENT_YEAR: new Date().getFullYear(),
};

export const PAGINATION_LIMITS = {
  ITEMS_PER_BATCH: 20,
  MAX_PAGES_PRELOAD: 5,
  LIST_PAGE_SIZE: 50,
};

export const VOTE_COUNT_THRESHOLDS = {
  MIN_QUALITY_VOTES: 30,
  MIN_RATING_VOTES: 50,
  HIGH_QUALITY_THRESHOLD: 3000,
  MIN_REVENUE: 1000,
};

export const CHART_LIMITS = {
  MAX_CAST_DISPLAY: 20,
  MAX_CREW_DISPLAY: 10,
  MAX_SIMILAR_ITEMS: 20,
};

export const RATE_LIMIT_CONFIG = {
  RETRY_AFTER_DEFAULT: 5000,
  MAX_RETRY_DELAY: 10000,
  EXPONENTIAL_BASE: 2,
};

export const MOVIE_HERO_VARIANTS = [
  { title: 'Tavo filmų', highlight: 'gidas', subtitle: 'Visi įvertinimai vienoje vietoje – IMDb, Rotten Tomatoes ir kur žiūrėti Lietuvoje' },
  { title: 'Ką šįvakar', highlight: 'žiūrim?', subtitle: 'Rask tobulą filmą su IMDb ir Rotten Tomatoes įvertinimais' },
  { title: 'Rask savo kitą', highlight: 'mėgstamiausią', subtitle: 'IMDb, Rotten Tomatoes ir kiti įvertinimai vienoje vietoje' },
  { title: 'Filmų', highlight: 'pasaulis', subtitle: 'Įvertinimai, atsiliepimai ir kur žiūrėti – viskas čia' },
  { title: 'Nerandi ką', highlight: 'žiūrėti?', subtitle: 'Palygink įvertinimus ir rask tobulą filmą vakarui' },
  { title: 'Visi filmai', highlight: 'vienoje vietoje', subtitle: 'IMDb, Rotten Tomatoes įvertinimai ir transliuotojai Lietuvoje' },
  { title: 'Tavo kino', highlight: 'kompasas', subtitle: 'Rask filmą pagal įvertinimus iš IMDb, Rotten Tomatoes ir kitų' },
  { title: 'Filmų', highlight: 'enciklopedija', subtitle: 'Įvertinimai, aprašymai ir kur žiūrėti Lietuvoje' },
  { title: 'Ieškai', highlight: 'perlo?', subtitle: 'Filtruok pagal įvertinimus ir atrask paslėptus deimančiukus' },
  { title: 'Kino vakaras', highlight: 'prasideda', subtitle: 'Palygink įvertinimus, perskaityk atsiliepimus ir rinkis' },
];

export const TV_HERO_VARIANTS = [
  { title: 'Tavo serialų', highlight: 'gidas', subtitle: 'Visi įvertinimai vienoje vietoje – IMDb, Rotten Tomatoes ir kur žiūrėti Lietuvoje' },
  { title: 'Ką šįvakar', highlight: 'žiūrim?', subtitle: 'Rask naują serialą su IMDb ir Rotten Tomatoes įvertinimais' },
  { title: 'Rask savo kitą', highlight: 'serialą', subtitle: 'IMDb, Rotten Tomatoes ir kiti įvertinimai vienoje vietoje' },
  { title: 'Serialų', highlight: 'pasaulis', subtitle: 'Įvertinimai, atsiliepimai ir kur žiūrėti – viskas čia' },
  { title: 'Baigei', highlight: 'serialą?', subtitle: 'Rask kitą pagal IMDb ir Rotten Tomatoes įvertinimus' },
  { title: 'Visi serialai', highlight: 'vienoje vietoje', subtitle: 'IMDb, Rotten Tomatoes įvertinimai ir transliuotojai Lietuvoje' },
  { title: 'Tavo serialų', highlight: 'kompasas', subtitle: 'Rask serialą pagal įvertinimus iš IMDb, Rotten Tomatoes ir kitų' },
  { title: 'Serialų', highlight: 'enciklopedija', subtitle: 'Įvertinimai, aprašymai ir kur žiūrėti Lietuvoje' },
  { title: 'Ieškai', highlight: 'perlo?', subtitle: 'Filtruok pagal įvertinimus ir atrask paslėptus deimančiukus' },
  { title: 'Maratonas', highlight: 'prasideda', subtitle: 'Palygink įvertinimus, perskaityk atsiliepimus ir rinkis' },
];
